
import { useParams } from 'react-router-dom';
import { DepositosFormState } from '../../../context/depositos/DepositosFormState';
import { Form } from './form';

export const DepositosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Deposito":"Crear Deposito";

  return (
    <DepositosFormState>
        <br />
        <Form title={title} />
    </DepositosFormState>
  );
};
